class UploadResumesController {
    /*@ngInject*/
    constructor($scope, $rootScope, $timeout, $uibModal, $filter, modalService, alertsAndNotificationsService, resumeService, jobService, MESSAGECONSTANTS, dateTimeUtilityService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.resumeService = resumeService;
        this.jobService = jobService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.dateTimeUtilityService = dateTimeUtilityService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    $onInit() {
        this.initVariables();
        // if(this.controlObject) {
        //     this.controlObject = {
        //         cancel: this.cancelUploadResumes
        //     };
        // }
        this.$scope.$on('cancelUploadResume', (event, arg) => {
            // this.cancelUploadResumes();
        });
        if (this.candidateId !== "") {
            this.isSingleCandidateUpload = true;
        }
        //initialize the variables
        if (!_.isNull(this.jobId) && this.jobId != '') {
            this.jobContextExistsFlag = true;
            this.createJobMatchesObject = {
                companyId: this.$rootScope.userDetails.company.companyId,
                requisitionId: this.jobId,
                candidateIds: [],
                manuallyMatchedFromUI: true,
                transactionId: null,
                isAssociateCandidate: false,
                overrideNoteDetails: []
            };
        }
        this.resumeList = [];
        // get the source types
        this.getAllSourceTypes(() => {
            if (!_.isNull(this.jobId) && this.jobId != '') {
                this.getLastAddedCandidateSourceTypeId();
            }
        });
        // wait for changes to take effect and then create wizard
        this.$timeout(() => {
            //initialize the drop zone configuration
            this.resumeUploadDropzone = this.createResumeUploadDropzone();
        }, 300);
        this._initializeUploadDatePicker();
    }
    initVariables() {
        this.defaultJobSourceTypeId;
        this.sourceTypeList = [];
        this.resumeList = [];
        this.sourceType = null;
        this.sourceTypeId = null;
        this.otherSourceTypeNotes = null;
        this.referrerName = null;
        this.referrerEmail = null;
        this.uploadResumesResponse = null;
        this.totalUploads = null;
        this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.candidateCount = null;
        this.createJobMatchesObject = null;
        this.addedFilesInDropzone = [];
        this.maxResumesToUpload = 40;
        this.uploadDate = null;
        this.displayUploadDate = null;
        // flags
        this.isSingleCandidateUpload = false;
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.disableCancelButtonFlag = false;
        this.fileUploadInProgressFlag = false;
        this.disableSourceTypesFlag = false;
        this.resumeScoringDoneFlag = false;
        this.scoringCandidatesFlag = false;
        this.jobContextExistsFlag = false;
        this.isUploadResumeWarningModalOpen = false;
    }
    getLastAddedCandidateSourceTypeId() {
        this.jobService.getLastAddedCandidateSourceTypeId(this.jobId, (data) => {
            this.defaultJobSourceTypeId = data.lastAddedCandidateSourceTypeId;
            this._setDefaultSourceType();
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    /**
     * creates the resume upload drop zone.
     */
    createResumeUploadDropzone() {
        let dropZoneSettings = this._getDropZoneSettings();
        let resumeUploadDropzone = new Dropzone("form#resumeUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        resumeUploadDropzone.on('addedfile', (file, response) => {
            this.fileExistsFlag = true;
            this.updateActionButtons();
            $('.dz-progress').css({ top: '70%' });
            this.addedFilesInDropzone.push(file);
            if (!this.isUploadResumeWarningModalOpen) {
                if (this.addedFilesInDropzone.length > this.maxResumesToUpload) {
                    this.isUploadResumeWarningModalOpen = true;
                    let title = 'Max Limit Exceeded';
                    let message = `There is a maximum limit of <b>${this.maxResumesToUpload}</b> resumes that can be uploaded at once. 
                    <br>You have currently exceeded this limit.
                    <br>We will reduce the number of files currently being uploaded to ${this.maxResumesToUpload}.
                    <br>The last file in this list is <b>${this.addedFilesInDropzone[this.maxResumesToUpload - 1]["name"]}</b>`;
                    this.alertsAndNotificationsService.showAlertWithCallBack(title, message, 'warning', () => {
                        this.isUploadResumeWarningModalOpen = false;
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        this.$timeout(() => {
                            $(".modal").addClass("four-dot-five-modal-large");
                        }, 200);
                    });
                }
            }
        });
        resumeUploadDropzone.on('maxfilesexceeded', (file, response) => {
            resumeUploadDropzone.removeFile(file);
        });
        resumeUploadDropzone.on('removedfile', (file, response) => {
            this.addedFilesInDropzone = this.addedFilesInDropzone.filter(resume => resume.upload.uuid !== file.upload.uuid);
            if (resumeUploadDropzone.files.length === 0) {
                this.disableUploadButtonFlag = true;
            }
            //do nothing as the resumes are processed async and it cannot be undone
        });
        resumeUploadDropzone.on('sendingmultiple', (file, xhr, formData) => {
            // disable the upload button to avoid multiple clicks
            this.disableUploadButtonFlag = true;
            // disable changing of source information
            this.disableSourceTypesFlag = true;
            // indicate that file upload is in progress
            this.fileUploadInProgressFlag = true;
            let resumeUpload = {};
            resumeUpload.companyId = this.$rootScope.userDetails.company.companyId;
            resumeUpload.userId = this.$rootScope.userDetails.id;
            resumeUpload.resumeSourceTypeId = this.sourceTypeId;
            resumeUpload.buIdList = [];
            // formData.append('resumeUpload', JSON.stringify(resumeUpload));
            formData.append("companyId", resumeUpload.companyId);
            formData.append("resumeSourceTypeId", resumeUpload.resumeSourceTypeId);
            formData.append("userId", resumeUpload.userId);
            formData.append("buIdList", resumeUpload.buIdList);
            if (this.sourceType.sourceType == 'Other') {
                formData.append("otherSourceTypeNotes", this.otherSourceTypeNotes);
            }
            else {
                formData.append("otherSourceTypeNotes", null);
            }
            if (this.sourceType.sourceType == 'Referral') {
                formData.append("referrerName", this.referrerName);
                formData.append("referrerEmail", this.referrerEmail);
            }
            else {
                formData.append("referrerName", null);
                formData.append("referrerEmail", null);
            }
            if (!_.isNull(this.jobId)) {
                formData.append("jobId", this.jobId);
            }
            if (this.uploadDate) {
                formData.append("uploadDateAndTime", this.uploadDate);
            }
        });
        resumeUploadDropzone.on('successmultiple', (fileArray, response) => {
            // remove file upload in progress flag
            this.fileUploadInProgressFlag = false;
            this.disableUploadButtonFlag = true;
            this.alertsAndNotificationsService.showBannerMessage(response.message, 'success');
            if (this.candidateProcessedCallback) {
                this.candidateProcessedCallback();
            }
            else if (this.completeCallback) {
                this.completeCallback();
            }
            // disable adding of further files
            $(".dz-hidden-input").prop("disabled", true);
            $('.dz-remove').hide();
        });
        resumeUploadDropzone.on("error", (file, error) => {
            let elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, (element, index) => {
                let filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                let errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
            this.disableNextButtonFlag = false;
        });
        return resumeUploadDropzone;
    }
    _getDropZoneSettings() {
        let dropZoneSettings = {};
        let maxFilesToUpload = this.maxResumesToUpload;
        if (this.isSingleCandidateUpload) {
            maxFilesToUpload = 1;
        }
        dropZoneSettings = {
            url: this.resumeService.getUploadUrl() + '/async',
            paramName: () => {
                return "file";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        if (this.jobContextExistsFlag) {
            dropZoneSettings.url = dropZoneSettings.url + "?jobId=" + this.jobId;
        }
        // else {
        //     dropZoneSettings = {
        //         url: this.resumeService.getUploadUrl(),
        //         paramName: () =>  {
        //             return "file";
        //         },
        //         acceptedFiles: ".pdf,.xlsx,.docx,.doc",
        //         maxFiles: 1,
        //         maxFilesize: 10,
        //         maxThumbnailFilesize: 10,
        //         timeout: 300000,
        //         addRemoveLinks: true,
        //         autoProcessQueue: false
        //     }
        // }
        return dropZoneSettings;
    }
    cancelUploadResumes() {
        let message = "Are you sure you want to cancel ?";
        let showPopUp = true;
        let createCandidatesFlag = false;
        if (this.resumeScoringDoneFlag) {
            // do nothing.
        }
        else {
            // scoring was not done
            if (this.resumeList.length) {
                // resumes were uploaded
                message = "No job matches will be created for the uploaded candidate(s).<br>Do you still want to continue?";
                createCandidatesFlag = true;
            }
            else if (this.resumeUploadDropzone.files.length > 0) {
                // resumes not uploaded, exist in the dropzone
                message = "Are you sure you want to cancel ?<br>Un-uploaded files exist in the upload area.";
            }
            else {
                // no uploaded resumes exist. no need to show confirmation popup.
                showPopUp = false;
            }
        }
        if (showPopUp) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: (result) => {
                    let message = "<p class='text-center'>Creating candidate(s) for uploaded resume(s) <i class='fa fa-spinner fa-spin'></i><br>Please go to Candidates screen to view the candidate(s).</p>";
                    if (result) {
                        if (createCandidatesFlag) {
                            let createUploadedCandidatesDialog = bootbox.dialog({
                                message: message,
                                closeButton: false
                            });
                            // scoring was not done and but resumes were uploaded.
                            // make service call to create candidates
                            this.resumeService.runResumesWithoutScoring(this.uploadResumesResponse, this.jobId, (data) => {
                                createUploadedCandidatesDialog.modal('hide');
                                this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                // candidates added successfully without creating job matches
                                if (this.cancelCallback) {
                                    this.cancelCallback();
                                }
                            }, (error) => {
                                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            });
                        }
                        else {
                            if (this.cancelCallback) {
                                this.cancelCallback();
                            }
                        }
                    }
                    else {
                        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            if (this.cancelCallback) {
                this.cancelCallback();
            }
        }
    }
    /**
     * update the action buttons
     */
    updateActionButtons() {
        // if resumes exist and scoring is completed, then the functions on this tab are disabled.
        if (this.resumeList.length > 0) {
            this.disableSourceTypesFlag = true;
            this.resumeUploadDropzone.clickable = false;
            this.disableUploadButtonFlag = true;
        }
        else {
            // in else because no resumes have been uploaded yet
            if (this.fileExistsFlag) {
                // if files exist in drop zone
                if (!_.isNull(this.sourceTypeId)) {
                    // and source type is chosen
                    this.disableUploadButtonFlag = false;
                    // this.disableSourceTypesFlag = true;
                }
                else {
                    // and source type is not chosen
                    this.disableUploadButtonFlag = true;
                    // this.disableSourceTypesFlag = false;
                }
            }
            else {
                // files do not exist in drop zone
                this.disableUploadButtonFlag = true;
                this.disableSourceTypesFlag = false;
            }
        }
        this.$timeout(() => {
            this.$scope.$apply();
        }, 200);
    }
    getAllSourceTypes(successCallback) {
        this.resumeService.getAllSourceTypes((data) => {
            this.sourceTypeList = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _setDefaultSourceType() {
        if (this.defaultJobSourceTypeId !== undefined && this.defaultJobSourceTypeId !== "" && !_.isNull(this.defaultJobSourceTypeId)) {
            let index = this.sourceTypeList.findIndex((sourceType) => {
                return sourceType.id == this.defaultJobSourceTypeId;
            });
            if (index !== -1) {
                this.sourceType = this.sourceTypeList[index];
                this.sourceTypeId = this.sourceType.id;
            }
        }
    }
    sourceTypeChanged() {
        if (angular.isDefined(this.sourceType) && angular.isDefined(this.sourceType.id)) {
            this.sourceTypeId = this.sourceType.id;
            this.updateActionButtons();
        }
        else {
            this.sourceTypeId = null;
        }
    }
    uploadResumes() {
        this.uploadResumesForm.$submitted = true;
        if (!this.uploadResumesForm.$invalid) {
            this.resumeUploadDropzone.processQueue();
        }
    }
    _initializeUploadDatePicker() {
        const today = new Date();
        const todayStr = today.toDateString(); // For comparison
        $('#displayUploadDate').datepicker({
            format: "M d, yyyy",
            endDate: today,
            weekStart: 1,
            autoclose: true
        });
        // Set initial date
        $("#displayUploadDate").datepicker("setDate", today);
        // 1. UI - show in M d, yyyy format
        this.displayUploadDate = this.$filter('fourdotfiveDateFormat')(today);
        $("#displayUploadDate").datepicker("update", this.displayUploadDate);
        // 2. Backend - store ISO timestamp
        this.uploadDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(today);
        $('#displayUploadDate').datepicker().on('changeDate', (e) => {
            const selectedDate = new Date(e.date);
            const selectedStr = selectedDate.toDateString();
            this.displayUploadDate = this.$filter('fourdotfiveDateFormat')(selectedDate); // Update UI display
            if (selectedStr === todayStr) {
                // Set uploadDate with current time
                this.uploadDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date());
            }
            else {
                // Set time to 11:59:59 PM for earlier dates
                selectedDate.setHours(23, 59, 59, 999);
                this.uploadDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(selectedDate);
            }
        });
    }
    receiveFormalizedComment(event) {
        this.otherSourceTypeNotes = event;
    }
    onVoiceTranscript(transcript) {
        if (this.otherSourceTypeNotes) {
            this.otherSourceTypeNotes += ' ' + transcript;
        }
        else {
            this.otherSourceTypeNotes = transcript;
        }
    }
}
UploadResumesController.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'alertsAndNotificationsService', 'resumeService', 'jobService', 'MESSAGECONSTANTS', 'dateTimeUtilityService'];
// import * as TEMPLATE from './upload-resumes.html';
import * as TEMPLATE from 'raw-loader!./upload-resumes.html';
export const UploadResumesComponent = {
    selector: 'uploadResumes',
    component: {
        bindings: {
            jobId: '@',
            candidateId: '@',
            cancelCallback: '&',
            candidateProcessedCallback: '&',
            completeCallback: '&',
            controlObject: '=',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: UploadResumesController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/upload-resumes.html'
    }
};
//# sourceMappingURL=upload-resumes.component.js.map